/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { IndexResponse } from './';
import {
    IndexResponseFromJSON,
    IndexResponseFromJSONTyped,
    IndexResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ElasticsearchClusterInformationResponse
 */
export interface ElasticsearchClusterInformationResponse {
    /**
     * 
     * @type {string}
     * @memberof ElasticsearchClusterInformationResponse
     */
    clusterName: string;
    /**
     * 
     * @type {string}
     * @memberof ElasticsearchClusterInformationResponse
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof ElasticsearchClusterInformationResponse
     */
    activeShardsPercent: number;
    /**
     * 
     * @type {number}
     * @memberof ElasticsearchClusterInformationResponse
     */
    activeShardsCount: number;
    /**
     * 
     * @type {number}
     * @memberof ElasticsearchClusterInformationResponse
     */
    nodesCount: number;
    /**
     * 
     * @type {{ [key: string]: Array<IndexResponse>; }}
     * @memberof ElasticsearchClusterInformationResponse
     */
    indices: { [key: string]: Array<IndexResponse>; };
}

/**
 * Check if a given object implements the ElasticsearchClusterInformationResponse interface.
 */
export function instanceOfElasticsearchClusterInformationResponse(value: object): value is ElasticsearchClusterInformationResponse {
    if (!('clusterName' in value) || value['clusterName'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('activeShardsPercent' in value) || value['activeShardsPercent'] === undefined) return false;
    if (!('activeShardsCount' in value) || value['activeShardsCount'] === undefined) return false;
    if (!('nodesCount' in value) || value['nodesCount'] === undefined) return false;
    if (!('indices' in value) || value['indices'] === undefined) return false;
    return true;
}

export function ElasticsearchClusterInformationResponseFromJSON(json: any): ElasticsearchClusterInformationResponse {
    return ElasticsearchClusterInformationResponseFromJSONTyped(json, false);
}

export function ElasticsearchClusterInformationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElasticsearchClusterInformationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clusterName': json['clusterName'],
        'status': json['status'],
        'activeShardsPercent': json['activeShardsPercent'],
        'activeShardsCount': json['activeShardsCount'],
        'nodesCount': json['nodesCount'],
        'indices': json['indices'],
    };
}

export function ElasticsearchClusterInformationResponseToJSON(value?: ElasticsearchClusterInformationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clusterName': value['clusterName'],
        'status': value['status'],
        'activeShardsPercent': value['activeShardsPercent'],
        'activeShardsCount': value['activeShardsCount'],
        'nodesCount': value['nodesCount'],
        'indices': value['indices'],
    };
}

